import { Helmet } from "react-helmet-async";

const Seo = () => {
  return (
    <>
      <Helmet>
        <title>
          Himalayan Utopia | Best Trekking & Adventure Tours in Nepal
        </title>
        <meta
          name="description"
          content="Discover trending Himalayan treks with jackpot deals! Explore top Nepal destinations: Everest, Annapurna, Langtang & more. Expert guides, safe adventures, unforgettable mountain & forest expeditions."
        />
        {/* Optional but recommended */}
        <meta
          name="keywords"
          content="Nepal trekking, Himalayan tours, Everest Base Camp, Annapurna trek, adventure Nepal"
        />
        <meta name="robots" content="index, follow" />
      </Helmet>
    </>
  );
};

export default Seo;
